// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"6923b2ff","434":"85c63194","884":"ae5c178d"}[chunkId] + ".chunk.js";
};